// extracted by mini-css-extract-plugin
export default {"popup-approve":"style_popup-approve__ILWmk"};